import { BoqPlanStateTypes, BoqPlanActionTypes } from "./BoqPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: BoqPlanStateTypes = {
  fetchAll: resetApiCallState([]),
};

const BoqPlanReducer = (
  state: BoqPlanStateTypes = INITIAL_STATE,
  action: any
): BoqPlanStateTypes => {
  switch (action.type) {
    case BoqPlanActionTypes.FETCH_ALL_BOQ_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case BoqPlanActionTypes.FETCH_ALL_BOQ_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BoqPlanActionTypes.FETCH_ALL_BOQ_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BoqPlanActionTypes.FETCH_ALL_BOQ_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default BoqPlanReducer;
